// import { useEffect, useState } from "react";
// import { useLocation, useNavigate, useNavigationType } from "react-router-dom";

// export default function ScrollHeight({ loading }) {
//   const [scrollStatus, setScrollStatus] = useState(false);
//   const [browserStatus, setBrowserStatus] = useState(false);

//   const location = useLocation();
//   const navigate = useNavigate();
//   const navigationType = useNavigationType();

//     useEffect(() => {
//       if (navigationType === "POP") {
//         setBrowserStatus(true);  // ✅ back/forward
//       } else {
//         setBrowserStatus(false); // ✅ normal navigation
//       }
//     }, [location, navigationType]);

//   useEffect(() => {
//     if (!loading) {
//       console.log("sdfdsf", loading)
//       const handleScroll = () => {
//         setScrollStatus(true);
//         const scrollPosition = window.scrollY;
//         localStorage.setItem(
//           `scroll-height${location.pathname}`,
//           scrollPosition
//         );
//       };
//       window.addEventListener("scroll", handleScroll);
//       return () => {
//         window.removeEventListener("scroll", handleScroll);
//       };
//     }
//   }, [location.pathname, loading]);
//   useEffect(() => {
//     if (!loading && browserStatus && !scrollStatus) {
//       const key = `scroll-height${location.pathname}`;
//       const savedScroll = localStorage.getItem(key);
//       if (savedScroll) {
//         const timeout = setTimeout(() => {
//           window.scrollTo({
//             top: parseFloat(savedScroll),
//             left: 0,
//             behavior: "smooth",
//           });
//         }, 800);
//         return () => clearTimeout(timeout);
//       }
//     }
//   }, [location.pathname, navigate, browserStatus, scrollStatus, loading]);
//   useEffect(() => {
//     setScrollStatus(false);
//   }, [navigate]);

//   return null;
// }

import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollHeight({ loading }) {
  const location = useLocation();
  const restoredRef = useRef(false);

  // SAVE scroll position
  useEffect(() => {
    if (loading) return;

    const handleScroll = () => {
      localStorage.setItem(
        `scroll-height${location.pathname}`,
        window.scrollY
      );
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname, loading]);

  // RESTORE scroll position
  useEffect(() => {
    if (loading) return;
    if (restoredRef.current) return;

    const key = `scroll-height${location.pathname}`;
    const savedScroll = localStorage.getItem(key);

    if (!savedScroll) return;

    const restore = () => {
      window.scrollTo({
        top: Number(savedScroll),
        behavior: "auto", // 👈 important: STOP exactly
      });
      restoredRef.current = true;
    };

    // wait for DOM & images
    const timeout = setTimeout(() => {
      requestAnimationFrame(restore);
    }, 300);

    return () => clearTimeout(timeout);
  }, [location.pathname, loading]);

  // Reset restore flag on route change
  useEffect(() => {
    restoredRef.current = false;
  }, [location.pathname]);

  return null;
}
